'use client'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'
import type * as React from 'react'

import { cn } from './cn'

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-border shadow-xs outline-none transition-[background-color,border-color,box-shadow] duration-quick ease-smooth-out focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:border-border dark:bg-input/30 dark:data-[state=checked]:bg-primary dark:aria-invalid:ring-destructive/40',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        forceMount
        data-slot="checkbox-indicator"
        className="group/checkbox-indicator grid place-content-center text-current"
      >
        <CheckIcon className="size-3.5 text-current [&_path]:transition-[stroke-dashoffset] [&_path]:duration-quick [&_path]:ease-smooth-out [&_path]:[stroke-dasharray:24_26] [&_path]:[stroke-dashoffset:25] group-data-[state=checked]/checkbox-indicator:[&_path]:duration-medium motion-reduce:[&_path]:transition-none group-data-[state=checked]/checkbox-indicator:[&_path]:[stroke-dashoffset:0] group-data-[state=indeterminate]/checkbox-indicator:[&_path]:[stroke-dashoffset:0]" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
